export default "__VITE_ASSET__ae6fc0da__"